import { gql } from '@apollo/client';

export const MESSAGE_FIELDS_FRAGMENT = gql`
  fragment MessageFields on Message {
    objectId: id
    createdAt
    originalCreatedAt
    messageType
    fromChannel
    source
    messagePlain
    direction
    messageBody
    toChannel
    subject
    messageHtml
    hiddenContent
    mediaUrl
    conversationId
    smbName
    hasRead
    status
    couponCodeId
    decisionTreeCouponCode
    noteType
    platformDomain
    platformTicketId
    customerId
    simplrAccountPtr {
      objectId: id
    }
    conversationPtr {
      objectId: id
    }
    couponCodePtr {
      objectId: id
      code
    }
    customerPtr {
      objectId: id
      customerFirstName
    }
    originalMessage
    detectedLanguage
    translatedMessage
  }
`;
